export default __webpack_public_path__ + "c01751e9cb2d98119003bf751735deeb.png";